// core/data/bookmarks.ts — typed seed for bookmarks + folders.
//
// Faithfully ported from legacy src/scripts/data/bookmarks.js.
// Each bookmark embeds its display fields inline.
// post/thread types carry postId for click-navigation.
// savedAt is a numeric sort key (higher = more recent).
// recent:true counts toward "Saved This Week".

import type { Bookmark, BookmarkFolder } from '@/core/models/bookmark';

export const seedBookmarkFolders: BookmarkFolder[] = [
  { id: 'inspirational', name: 'Inspirational Posts' },
  { id: 'design',        name: 'Design Inspiration' },
  { id: 'tech',          name: 'Tech & AI' },
  { id: 'business',      name: 'Business' },
  { id: 'watch-later',   name: 'Watch Later' },
  { id: 'read-later',    name: 'Read Later' },
];

export const seedBookmarks: Bookmark[] = [
  {
    id: 'bm-01',
    type: 'post',
    folderId: 'tech',
    savedAt: 12,
    time: '2h',
    recent: true,
    title: "Freedom isn't just a right.",
    source: 'WayneTech',
    handle: '@WayneTech',
    snippet: 'Protect it. Defend it. Live it.',
    media: false,
    postId: 'post-004',
  },
  {
    id: 'bm-02',
    type: 'thread',
    folderId: 'business',
    savedAt: 11,
    time: '5h',
    recent: true,
    title: 'Decentralization is digital sovereignty.',
    source: 'WayneTech',
    handle: '@WayneTech',
    snippet: "The future is in our hands. Let's build it together.",
    media: false,
    postId: 'post-005',
  },
  {
    id: 'bm-03',
    type: 'people',
    folderId: 'inspirational',
    savedAt: 10,
    time: '8h',
    recent: false,
    title: 'FreeThinker',
    source: 'Suggested for you',
    handle: '@FreeThinker',
    snippet: 'Independent voice, 48.2K followers',
    media: false,
    postId: null,
  },
  {
    id: 'bm-04',
    type: 'community',
    folderId: 'business',
    savedAt: 9,
    time: '1d',
    recent: false,
    title: 'Entrepreneurs Hub',
    source: 'Community',
    handle: null,
    snippet: '12.4K members building businesses that last',
    media: false,
    postId: null,
  },
  {
    id: 'bm-05',
    type: 'video',
    folderId: 'watch-later',
    savedAt: 8,
    time: '1d',
    recent: true,
    title: 'The Future of AI & Humanity',
    source: 'TechVisionary',
    handle: '@TechViz',
    snippet: '24:18. A grounded look at where this is heading.',
    media: true,
    postId: null,
  },
  {
    id: 'bm-06',
    type: 'article',
    folderId: 'read-later',
    savedAt: 7,
    time: '2d',
    recent: false,
    title: '10 Mental Models That Changed My Life',
    source: 'Mindset Daily',
    handle: null,
    snippet: '8 min read. Frameworks for clearer thinking.',
    media: true,
    postId: null,
  },
  {
    id: 'bm-07',
    type: 'product',
    folderId: 'design',
    savedAt: 6,
    time: '2d',
    recent: false,
    title: 'Noise Cancelling Headphones',
    source: 'AudioLab',
    handle: null,
    snippet: '$249. Studio-grade sound, all-day comfort.',
    media: true,
    postId: null,
  },
  {
    id: 'bm-08',
    type: 'post',
    folderId: 'inspirational',
    savedAt: 5,
    time: '3d',
    recent: false,
    title: "The truth doesn't need permission.",
    source: 'FreedomSeeker',
    handle: '@FreedomSeeker',
    snippet: 'It just needs to be spoken.',
    media: false,
    postId: 'post-001',
  },
  {
    id: 'bm-09',
    type: 'video',
    folderId: 'watch-later',
    savedAt: 4,
    time: '3d',
    recent: false,
    title: "Building in Public: A Founder's Journey",
    source: 'StartupStories',
    handle: null,
    snippet: '41:02. Lessons from zero to launch.',
    media: true,
    postId: null,
  },
  {
    id: 'bm-10',
    type: 'article',
    folderId: 'tech',
    savedAt: 3,
    time: '4d',
    recent: false,
    title: 'Understanding Neural Networks',
    source: 'AI Weekly',
    handle: null,
    snippet: '12 min read. A plain-English primer.',
    media: true,
    postId: null,
  },
  {
    id: 'bm-11',
    type: 'community',
    folderId: 'design',
    savedAt: 2,
    time: '5d',
    recent: false,
    title: 'Design Masters',
    source: 'Community',
    handle: null,
    snippet: '6.8K members. Critique, share, and grow.',
    media: false,
    postId: null,
  },
  {
    id: 'bm-12',
    type: 'people',
    folderId: 'business',
    savedAt: 1,
    time: '6d',
    recent: false,
    title: 'WayneTech',
    source: 'Suggested for you',
    handle: '@WayneTech',
    snippet: 'Verified, building the open web',
    media: false,
    postId: null,
  },
];
